import { Switch, Route } from "wouter";
import { Toaster } from "@/components/ui/toaster";
import { ThemeProvider } from "@/components/ThemeProvider";
import { lazy, Suspense } from "react";

const Home = lazy(() => import("@/pages/home"));
const VacationRentals = lazy(() => import("@/pages/vacation-rentals"));
const WeddingsEvents = lazy(() => import("@/pages/weddings-events"));
const WeddingInquiry = lazy(() => import("@/pages/wedding-inquiry"));
const WeddingThankYou = lazy(() => import("@/pages/wedding-thank-you"));
const WeddingsLanding = lazy(() => import("@/pages/weddings-landing"));
const WellnessLanding = lazy(() => import("@/pages/wellness-landing"));
const CorporateLanding = lazy(() => import("@/pages/corporate-landing"));
const CorporateWellnessEvents = lazy(() => import("@/pages/corporate-wellness-events"));
const GroupsRetreats = lazy(() => import("@/pages/groups-retreats"));
const EventsInquiry = lazy(() => import("@/pages/events-inquiry"));
const EventsThankYou = lazy(() => import("@/pages/events-thank-you"));
const FilmRentals = lazy(() => import("@/pages/film-rentals"));
const History = lazy(() => import("@/pages/history"));
const PrivacyPolicy = lazy(() => import("@/pages/privacy-policy"));
const TermsConditions = lazy(() => import("@/pages/terms-conditions"));
const EntireEstateBooking = lazy(() => import("@/pages/entire-estate-booking"));
const BookNow = lazy(() => import("@/pages/book-now"));
const NotFound = lazy(() => import("@/pages/not-found"));

function Router() {
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/vacation-rentals" component={VacationRentals} />
        <Route path="/weddings" component={WeddingsEvents} />
        <Route path="/wedding-inquiry" component={WeddingInquiry} />
        <Route path="/wedding-thank-you" component={WeddingThankYou} />
        <Route path="/weddings-in-desert-hot-springs" component={WeddingsLanding} />
        <Route path="/events-retreats" component={GroupsRetreats} />
        <Route path="/events-inquiry" component={EventsInquiry} />
        <Route path="/events-thank-you" component={EventsThankYou} />
        <Route path="/film-rentals" component={FilmRentals} />
        <Route path="/wellness-retreats-in-desert-hot-springs" component={WellnessLanding} />
        <Route path="/corporate-retreats-in-desert-hot-springs" component={CorporateLanding} />
        <Route path="/corporate-wellness-events" component={CorporateWellnessEvents} />
        <Route path="/desert-hot-springs-luxury-hotel-booking" component={EntireEstateBooking} />
        <Route path="/book-now" component={BookNow} />
        <Route path="/history" component={History} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/terms-conditions" component={TermsConditions} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="bubbling-wells-theme">
      <Toaster />
      <Router />
    </ThemeProvider>
  );
}

export default App;
